import Clipboard from 'clipboard';
import Vue from 'vue'
import i18n from '../main.js'

const clipboard = {
  bind(el, bingind, vnode) {
    const clip = new Clipboard(el);
    el.dataset.clipboardText = bingind.value;
    clip.on('success', e => {
      Vue.prototype.$message({
        showClose: true,
        message: i18n.$t('复制成功:')+e.text,
        type: 'success'
      });

    });
    clip.on('error', e => {

      Vue.prototype.$message({
        showClose: true,
        message: '复制失败,您的浏览器不支持复制',
        type: 'error'
      });

    });
  },
  update(el, bingind) {
    el.dataset.clipboardText = bingind.value;
  }
}

clipboard.install = function (Vue) {
  Vue.directive('clipboard', clipboard)
}

export default clipboard



// WEBPACK FOOTER //
// ./src/directive/clipboard.js